import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Schedule from '../components/profile/Schedule';
import Logout from '../components/profile/Logout';
import { useAppSelector } from '../hooks/store';
import getFileURL from '../utils/getFileURL';
import './Profile.css';
import SwitchToSearch from '../components/profile/SwitchToSearch';
import { useNavigate } from 'react-router-dom';
import Modal from '../components/common/Modal';

export interface ProfileProps {
	refSearch: React.RefObject<HTMLDivElement>,
    refProfile: React.RefObject<HTMLDivElement>,
};

const Profile: FC<ProfileProps> = ({ refSearch, refProfile }) => {
	const { t, i18n } = useTranslation();
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const user = useAppSelector(store => store.auth.user);
    const event = useAppSelector(store => store.event);
    const navigate = useNavigate();
    const [ showPopup, setShowPopup ] = useState(false);
    const [ popupText, setPopupText ] = useState<string|null>(null);
    const [ popupSubmit, setPopupSubmit ] = useState<string|null>(null);

    // Вычисляем надо ли показать попап с просьбой о заполнении профиля
    useEffect(() => {
        if(!user || !event) return;
        if(event.editing_until) {
            // Если уже нельзя редактировать профайл, то незачем показывать попап
            const today = Date.now() + 3 * 60 * 60 * 1000; // +3 часа
            const until = Date.parse(event.editing_until);
            if(today > until) return;
        }
        // Проверим заполнненность полей
        if(!user.company_ru || !user.company_en || !user.description_ru || !user.description_en || user.categories.length < 1) {
            setShowPopup(true);
            let need_profile = false;
            let need_categories = user.categories.length < 1 ? true : false;
            if(!user.company_ru || !user.company_en || !user.description_ru || !user.description_en) need_profile = true;
            if(need_profile && need_categories) {
                setPopupText(t(`profile.popup.${user.role}`));
                setPopupSubmit(t('profile.popup.submit'));
            } else if(need_profile) {
                setPopupText(t(`profile.popup.profile`));
                setPopupSubmit(t('profile.popup.submit'));
            } else {
                setPopupText(t(`profile.popup.${user.role}_categories`));
                setPopupSubmit(t(`profile.popup.submit_${user.role}`));
            }
        }
    }, [ user, event, t ]);


    if(!event) return <div className='error'>{t('common.noevent')}</div>;
    if(!user) return <div className='error'>{t('common.nouser')}</div>;

    return (
		<div>
            <Logout/>
            <SwitchToSearch refSearch={refSearch} refProfile={refProfile}/>
			<h1>{t('profile.title.profile')}</h1>
            <div className='Profile'>
                <div className='Info'>
                    <div className='Name'>{user[name]}</div>
                    <div
                        className='Link'
                        onClick={() => navigate('infoview')}
                    >
                        {t('profile.view')}
                    </div>
                </div>
                <img alt='avatar' className='Avatar' src={getFileURL(user.avatar)}/>
            </div>
            <Schedule/>

            <Modal
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
            >
                <h1>{t('profile.popup.title')}</h1>
                <p>{popupText}</p>
                <span
                    className='button'
                    onClick={() => { setShowPopup(false); navigate('infoview');}}
                >
                    {popupSubmit}
                </span>
            </Modal>
		</div>
	);
};

export default Profile;
